var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tabsInfo)?_c('div',{class:[
    _vm.tabsInfo.slotTitle ? 's-tab-nav' : 's-tab-wrap',
    { 'is-active': _vm.isActive },
    { 'is-disabled': _vm.disabled }
  ],style:(_vm.tabsInfo.slotTitle
      ? 'color:' + (_vm.isActive ? _vm.tabsInfo.activeColor : _vm.tabsInfo.color)
      : ''),on:{"click":_vm.navClick}},[(_vm.tabsInfo.slotTitle)?_vm._t("default"):_c('div',{staticClass:"s-tab-panel"},[(!_vm.tabsInfo.lazyRender || _vm.info.isRender)?_vm._t("default"):_vm._e()],2)],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6c278e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s-tab/index.vue
// module id = null
// module chunks = 